
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCapacitor03Off as ObiCapacitor03OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-capacitor-03-off.js';
 
 
 

 
 export const ObiCapacitor03Off = createComponent({
   react: React,
   tagName: 'obi-capacitor-03-off',
   elementClass: ObiCapacitor03OffElement,
   events: {
     
   }
  });
 
 